(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('invoices-data', {
            parent: 'account',
            url: '/invoices-data',
            data: {
                authorities: ['PERM_USER_SUPERADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/statistics/invoices-data/invoices-data.template.html',
                    controller: 'InvoicesDataController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statistics');
                    return $translate.refresh();
                }]
            }
        })
        ;
    }
})();
